const euCountries = [
  { code: "BE", name: "Belgium" },
  { code: "DE", name: "Germany" },
  { code: "FR", name: "France" },
  { code: "IE", name: "Ireland" },
  { code: "NL", name: "Netherlands" },
];

const getRegionNames = (language?: string) => {
  if (typeof Intl === "undefined" || !("DisplayNames" in Intl)) return null;
  try {
    return new Intl.DisplayNames([language ?? "en", "en"], { type: "region" });
  } catch {
    return null;
  }
};

export const getEuCountryOptions = (language?: string) => {
  const regionNames = getRegionNames(language);

  return euCountries.map(({ code, name }) => ({
    value: code,
    label: regionNames?.of(code) ?? name,
  }));
};

export default euCountries;
